import LinkButton from "ds/components/Button/LinkButton";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import { getDocsUrl } from "utils/getDocsUrl";

const StackSettingsRolesAdministrativeBanner = () => {
  return (
    <Callout
      title="Administrative access is enabled"
      variant="warning"
      storageKey="stack-settings-roles-administrative-banner"
    >
      Attached roles are currently ignored. To activate role-based permissions, disable
      administrative access in the stack behavior section.
      <FeedbackActions>
        <LinkButton variant="contrast" size="small" to="../behavior">
          Change settings
        </LinkButton>
        <LinkButton
          variant="secondary"
          size="small"
          href={getDocsUrl("/concepts/stack/stack-settings#administrative")}
          target="_blank"
        >
          Documentation
        </LinkButton>
      </FeedbackActions>
    </Callout>
  );
};

export default StackSettingsRolesAdministrativeBanner;
